interface Props {
  children: React.ReactNode
}

export const HearingLayout = (props: Props): JSX.Element => {
  return (
    <main className="min-h-screen bg-white flex flex-col">
      <section className="flex flex-col grow">{props.children}</section>
    </main>
  )
}
